import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';
import { ProviderUser } from '@sondermind/utilities/models-user-provider';

@Component({
  selector: 'member-profile-license-insurance',
  templateUrl: './profile-license-insurance.component.html',
  styleUrls: ['./profile-license-insurance.component.scss', '../../modules/profile/profile-app-shared-styles.scss'],
  standalone: false
})
export class ProfileLicenseInsurancePage implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();
  user: ProviderUser = null;
  credentialListLoaded: boolean = false;
  networkListLoaded: boolean = false;

  constructor(
    private appService: SondermindApplicationService
  ) {}

  get loaded(): boolean {
    return this.credentialListLoaded && this.networkListLoaded;
  }

  ngOnInit(): void {
    this.loadUser();
  }

  loadUser(): void {
    this.appService.currentUser$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((u) => {
      this.user = u;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  handleCredentialsChanged(): void {
    this.credentialListLoaded = true;
    // kick off reload so we get new profile submission errors
    this.appService.reloadCurrentUser();
  }
}
